import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay, throttleTime } from 'rxjs/operators';
import { NotificationType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private notificationTypes$$ = new BehaviorSubject<NotificationType[]>(null);
  private notificationTypesThrottle$$ = new Subject();
  private notificationTypesShared$ = this.notificationTypes$$.asObservable().pipe(shareReplay(1));
  public get notificationTypes$(): Observable<NotificationType[]> {
    this.notificationTypesThrottle$$.next();
    return this.notificationTypesShared$;
  }

  constructor(private httpClient: HttpClient, private logger: NGXLogger) {
    this.notificationTypesThrottle$$.pipe(throttleTime(1000)).subscribe(() => {
      this.loadNotificationTypes();
    });
  }

  private async loadNotificationTypes() {
    try {
      const result = await this.httpClient
        .get<NotificationType[]>(`${environment.api}/v1/user/notification/settings`)
        .toPromise();
      this.notificationTypes$$.next(result);
    } catch (error) {
      this.logger.error(error);
    }
  }

  public async toggleNotification(typeId: string, enabled: boolean) {
    try {
      const response = await this.httpClient
        .post<{ updatedType: NotificationType }>(`${environment.api}/v1/user/notification/toggle`, {
          typeId,
          enabled,
        })
        .toPromise();

      const notifications = this.notificationTypes$$.value;
      if (!response || !response.updatedType || !notifications || !notifications.length) {
        return;
      }
      const index = notifications.findIndex((n) => n.id === response.updatedType.id);
      if (index === -1) {
        return;
      }
      const copyOfNotifications = [...notifications];
      copyOfNotifications[index] = response.updatedType;
      this.notificationTypes$$.next(copyOfNotifications);
    } catch (error) {
      this.logger.error(error);
    }
  }
}
